/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner } from './get-slack-evidence-reminder-per-channel200-response-settings-inner-reminders-inner';

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInner
 */
export interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInner
     */
    'notificationScope': GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner>}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInner
     */
    'reminders': Array<GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner>;
}

export const GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum = {
    thisMonth: 'THIS_MONTH',
    prevMonth: 'PREV_MONTH'
} as const;

export type GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum = typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum[keyof typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum];


